import { sendApiFailedEvent } from "@elixir/analytics";
import {
  GET_AORTA_GO_HOST,
  GET_CLIENT_ID,
  GET_EXTRA_HEADERS,
} from "../constants/env";
import { Contacts, IBridge } from "../types/generic";

export async function refreshToken() {
  const refreshOnNative = await updateToken();
  if (refreshOnNative) {
    return true;
  }
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.set("client-id", GET_CLIENT_ID());
  const raw = JSON.stringify({});

  const requestOptions: RequestInit = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
    credentials: "include",
    mode: "cors",
  };
  try {
    const AORTA_GO_HOST = GET_AORTA_GO_HOST();
    const response = await fetch(`${AORTA_GO_HOST}/emr/v3/auth/refresh`, {
      ...requestOptions,
      body: JSON.stringify({}),
    });
    if (response.status === 401) {
      return false;
    }
  } catch (error) {
    return false;
  }
  return true;
}

export default async function fetchWrapper(
  url: RequestInfo,
  options: RequestInit | undefined = {},
  retry: boolean = true,
  omitClientId: boolean = false
): Promise<Response> {
  try {
    const fallbackAuth = window?.Eka?.getSessionToken?.() || "";
    const newHeaders = new Headers(options.headers);

    let clientId;

    let currentPathname;

    if (!newHeaders.get("client-id") && !omitClientId) {
      newHeaders.set("client-id", GET_CLIENT_ID());
    }

    if (fallbackAuth && !newHeaders.get("auth")) {
      newHeaders.set("auth", fallbackAuth);
    }

    // if (!newHeaders.get("x-eka-pt-oid")) {
    //   newHeaders.set("x-eka-pt-oid", GET_EKA_OID());
    // }

    const extraHeaders = GET_EXTRA_HEADERS(); 
    if (extraHeaders) {
      Object.keys(extraHeaders).forEach((key) => {
        newHeaders.set(key, extraHeaders[key]);
      });
    }

    const response: Response = await fetch(url, {
      ...options,
      headers: newHeaders,
    });
    if (!!window) {
      currentPathname = window.location.pathname;
      clientId = newHeaders.get("client-id");
    }
    if (response.status === 401 && retry) {
      const loginSuccess = await refreshToken();
      if (loginSuccess) {
        return await fetchWrapper(url, options, false);
      }
    }
    if (response.status > 401) {
      sendApiFailedEvent({
        url: url as string,
        params: { responseStatus: response.status },
      });
    }
    return response;
  } catch (error: any) {
    sendApiFailedEvent({
      url: url as string,
      params: { error: `${error.message || error}` },
    });
    console.error(error);
    throw error;
  }
}

let androidRefreshCB: Function[] = [];

async function refreshCallback(arg: any) {
  // updateEkaHeaders();
  androidRefreshCB.forEach((res) => res(true));
  androidRefreshCB = [];
}

export async function updateToken() {
  if (typeof window !== "undefined") {
    if (typeof window?.Eka?.updateToken === "function") {
      window.parent?.postMessage({ type: "REFRESH_TOKEN" }, "*");
      window.refreshCallback = window.refreshCallback || refreshCallback;
      return new Promise((res) => {
        androidRefreshCB.push(res);
        window?.Eka?.updateToken("refreshCallback");
      });
    }

    if (
      typeof window?.webkit?.messageHandlers?.statusCodeHandler?.postMessage ===
      "function"
    ) {
      window.parent?.postMessage({ type: "REFRESH_TOKEN" }, "*");
      window.refreshCallback = window.refreshCallback || refreshCallback;
      return new Promise((res) => {
        androidRefreshCB.push(res);
        window?.webkit?.messageHandlers?.statusCodeHandler?.postMessage(
          JSON.stringify({ status: 401 })
        );
      });
    }
  }
  return false;
}

declare global {
  interface Window {
    Eka?: IBridge & {
      getSessionToken: () => string;
      updateToken: (callbackFunctionName: string) => void;
      getHeaders: () => string;
      isRNCompatible: () => string;
      getContacts: (
        contactSuccessCallback: string,
        contactErrorCallback: string,
        limit: number
      ) => Contacts | void;
      navigateTo: (pid: string, params: string) => void;
      refreshCallback: Record<string, any>;
      closeActivity: () => void;
    };
    webkit?: {
      messageHandlers: {
        [Property in keyof IBridge]: { postMessage: Function };
      } & {
        statusCodeHandler: { postMessage: Function };
        supportChat: { postMessage: Function };
      };
    };
    refreshCallback?: (arg: any) => void;
  }
}
